import { CONFIG } from './config';

export function isStandvastEmail(email: string) {
  const regexp = new RegExp(
    `${CONFIG().standvastEmailDomain.replace('.', '\\.')}$`
  );
  return regexp.test(email);
}
